import { createActions, createReducer } from 'reduxsauce';
import {
  BASE_INITIAL_STATE,
  DETAILS_SET_INITIAL_STATE,
  FAVOURITE_ACTIONS_SET,
  BASE_DETAILS_ACTIONS_SET,
  getRequestDetailsHandler,
  getSuccessDetailsHandler,
  getFailureDetailsHandler,
  toggleFavouriteInBusinessDetail,
} from '../../../store/structures';

export const AFFILIATE_BUSINESS_COUPONS_INITIAL_STATE = BASE_INITIAL_STATE;

const { Types, Creators } = createActions(
  {
    getDetail: ['id'],
    ...BASE_DETAILS_ACTIONS_SET,
    ...FAVOURITE_ACTIONS_SET,
  },
  {
    prefix: 'cb/affiliatebusinesses/coupons/',
  },
);

export { Types as types, Creators as actions };

const HANDLERS = {
  [Types.REQUEST]: getRequestDetailsHandler(AFFILIATE_BUSINESS_COUPONS_INITIAL_STATE),
  [Types.SUCCESS]: getSuccessDetailsHandler(),
  [Types.FAILURE]: getFailureDetailsHandler(),
  [Types.TOGGLE_FAVOURITE]: toggleFavouriteInBusinessDetail,
};

export default createReducer(DETAILS_SET_INITIAL_STATE, HANDLERS);
